import AlertsNotification from './AlertsNotification'

export default AlertsNotification
